/** it was decided to not use doppler vars for these */
export const BRAND_ID = {
  farewill: '95c11e40-b445-4b3a-b368-f16b33274d30',
  dignity: '0808862d-f899-447f-b251-f744eec5122b',
  simplicity: '24ed1163-2767-464b-bd39-753193744a40',
} as const

export const BRAND_IDS = Object.values(BRAND_ID)
export type BrandId = (typeof BRAND_ID)[keyof typeof BRAND_ID]
export type FuneralBrandId = Exclude<BrandId, typeof BRAND_ID.dignity>

export const MAP_BRAND_ID_TO_NAME: Record<string, string> = {
  [BRAND_ID.farewill]: 'Farewill',
  [BRAND_ID.dignity]: 'Dignity',
  [BRAND_ID.simplicity]: 'Simplicity',
} as const

export const ACTIVE_BRANDS = [
  { value: BRAND_ID.dignity, label: 'Dignity' },
  { value: BRAND_ID.farewill, label: 'Farewill' },
  { value: BRAND_ID.simplicity, label: 'Simplicity' },
]
